enum Apps {
	TherapyEd = "therapyed",
	Psi = "psi",
	Toefl = "toefl",
	Simwerx = "simwerx",
	Jbjs = "jbjs",
	Ada = "ada",
	zoetis = "zoetis",
	thiemeneetpg = "thiemeneetpg",
	hiset = "hiset",
	Proethica = "proethica",
}
export type AppIds =
	| "com.memorang.therapyed"
	| "com.memorang.psi.insurance"
	| "com.memorang.psi.insurance.testprep"
	| "com.memorang.thieme.india.medical"
	| "com.memorang.simwerx"
	| "com.memorang.ets.toefl"
	| "org.ets.toeflpracticeaicoach"
	| "com.memorang.demo.app";
export { Apps };
